import { render, staticRenderFns } from "./RemarkListAddNew.vue?vue&type=template&id=7e1d4d16&"
import script from "./RemarkListAddNew.vue?vue&type=script&lang=js&"
export * from "./RemarkListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports